<template>
  <th class="subsearch-toggle-area-bar" id="detailedsearch_tit_hold_days">
    <p class="detailedsearch_tit">
      開催日数
    </p>

    <ul class="detailedsearch_list">
      <li v-for="item in holdDaysStore.master" :key="item.code">
        <label :for="`hold_days_${item.code}`">
          <input type="checkbox"
                v-model="checkboxValue"
                :id="`hold_days_${item.code}`"
                :value="item.code">
          <span>{{ item.text }}</span>
        </label>
      </li>
    </ul>
  </th>
</template>

<script setup>
import { computed, inject } from 'vue'

const holdDaysStore = inject('holdDaysStore')
const checkboxValue = computed({
  get: () => holdDaysStore.holdDays.value,
  set: (value) => { holdDaysStore.set(value) }
})
</script>
